var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7989 11.6577V16.7594H12.3854V8.96759C12.957 9.16421 14.3042 9.50359 14.9455 9.78388C15.6061 10.0726 15.7989 10.8869 15.7989 11.6577Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44336 16.7594H12.3854M16.5567 16.7594H15.7989M15.7989 16.7594V11.6577C15.7989 10.8869 15.6061 10.0726 14.9455 9.78388C14.3042 9.50359 12.957 9.16421 12.3854 8.96759V16.7594M15.7989 16.7594H12.3854",
    stroke: "#585858",
    strokeWidth: 0.996065,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06934 16.2943V7.00322C4.06934 5.40058 4.06934 4.59862 4.57439 4.20083C5.07945 3.80304 5.8233 4.01949 7.31166 4.45112L10.5042 5.37759C11.4019 5.6381 11.8508 5.76836 12.11 6.124C12.3699 6.47901 12.3699 6.96236 12.3699 7.93033V16.2943",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06934 16.2943V7.00322C4.06934 5.40058 4.06934 4.59862 4.57439 4.20083C5.07945 3.80304 5.8233 4.01949 7.31166 4.45112L10.5042 5.37759C11.4019 5.6381 11.8508 5.76836 12.11 6.124C12.3699 6.47901 12.3699 6.96236 12.3699 7.93033V16.2943",
    stroke: "#585858",
    strokeWidth: 0.957755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26204 8.46092H9.17755M7.26204 11.0149H9.17755M9.81605 16.6805V14.846C9.81605 14.2438 9.81605 13.9431 9.62897 13.756C9.44189 13.5689 9.14115 13.5689 8.53904 13.5689H7.90054C7.29843 13.5689 6.9977 13.5689 6.81062 13.756C6.62354 13.9431 6.62354 14.2438 6.62354 14.846V16.7001",
    stroke: "#585858",
    strokeWidth: 0.957755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientMenuIcon);
export default __webpack_public_path__ + "static/media/client-menu-icon.fc9d9c896c1c05d6c3f4ee60a6f0cc50.svg";
export { ForwardRef as ReactComponent };